const endPoint = {
  faq: '/wp-json/app/v1/categories/faq', // GET
  search: '/wp-json/app/v1/search',
  news: '/wp-json/app/v1/news', // GET
  premise: '/wp-json/app/v1/premise', // GET
  contact: '/wp-json/app/v1/contact', // POST
  error: '/wp-json/app/v1/errorcontact', // POST
  availability: '/wp-json/app/v1/availabilitycontact', // POST
  budgetOffer: '/wp-json/app/v1/accommodation/budget', // POST
  budgetVote: '/wp-json/app/v1/accommodation/vote', // POST
  sponsorApplication: '/wp-json/app/v1/sponsoring/apply', // POST
  studentApplication: '/wp-json/app/v1/student/apply', // POST
  thoughtsAboutOBO: '/wp-json/app/v1/thoughts/send', // POST
  employees: 'wp-json/app/v1/contacts/search', // GET
  feed: '/wp-json/app/v1/feed', // GET
  subscribeJobs: '/wp-json/app/v1/subscribe/jobs', // POST
  subscribePremises: '/wp-json/app/v1/subscribe/premises', // POST
  unsubscribe: '/wp-json/app/v1/unsubscribe', // POST
};

export default endPoint;
